import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { BulkActionJobDto } from 'lib';
import { PaginatedSearchFilter, PaginatedSearchResponse } from 'lib';

@Injectable({
    providedIn: 'root'
})
export class BulkActionJobService {
    private http = inject(HttpClient);


    baseUrl = '';

    constructor() {
        this.baseUrl = environment.apiUrl + '/api/v1/bulk-action';
    }

    uploadByEnterprise(enterpriseId: number, formData: FormData): Observable<number> {
        return this.http.post<number>(`${this.baseUrl}/${enterpriseId}/upload`, formData);
    }

    getByEnterprise(enterpriseId: number): Observable<BulkActionJobDto[]> {
        return this.http.get<BulkActionJobDto[]>(`${this.baseUrl}/${enterpriseId}`);
    }

    getByEnterpriseId(enterpriseId: number, filter: PaginatedSearchFilter):
        Observable<PaginatedSearchResponse<BulkActionJobDto>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams()
            .set('page', filter.page)
            .set('size', filter.itemsPerPage)
            .set('sort', filter.sortBy + ',' + filter.sortOrder);
        return this.http.get<PaginatedSearchResponse<BulkActionJobDto>>(`${this.baseUrl}/${enterpriseId}`, { headers, params });
    }

    executeByEnterprise(enterpriseId: number): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/${enterpriseId}/execute`, null);
    }

    downloadCsv(enterpriseId: number, fileName: string): Observable<string> {
        return this.http.get(`${this.baseUrl}/${enterpriseId}/${fileName}`, { responseType: 'text' });
    }
}
